import { useAuthProvider } from '@maui-mf/common-react'
import { useUserPreferencesQuery } from '@nautilusjs/mati-shared'
import { useFeatureFlag } from './useFeatureFlag'

export const useDuetAi = () => {
  const enabled = useFeatureFlag('duet_ai_feature')
  const { claims = {} } = useAuthProvider()

  const isl = claims.isl || []

  const entitled = isl.includes('INTEL_RBI_FUS') || isl.includes('INTEL_RBI_OPS')

  const {
    data: preferences = {},
    isLoading,
    fetchStatus
  } = useUserPreferencesQuery({ enabled: enabled && entitled })

  return {
    isLoading: isLoading && fetchStatus !== 'idle',
    enabled,
    entitled,
    prefersDuetAi: preferences.searchPreference === 'gemini'
  }
}
